// extracted by mini-css-extract-plugin
export default {"container":"src-feature-ui-__section-title_container","icon":"src-feature-ui-__section-title_icon"};